import React from "react";
import { useSelector, useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import { activeItem } from "../../../../../redux/slices/menu/menuSlice";

function NavItem({ item }) {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const drawerOpen = useSelector((s) => s.menu.drawerOpen);
  const selected = useSelector((s) => s.menu.openItem[0]);
  const isActive = selected === item.id;

  const handleClick = () => {
    dispatch(activeItem({ openItem: [item.id] }));
    navigate(item.url);
  };

  return (
    <button
      onClick={handleClick}
      style={{
        ...styles.item,
        backgroundColor: isActive ? "rgba(255,255,255,0.2)" : "transparent",
        color: "#ffffff",
        borderColor: isActive ? "rgba(255,255,255,0.4)" : "transparent",
        justifyContent: drawerOpen ? "flex-start" : "center",
        padding: drawerOpen ? "10px 12px" : "10px",
      }}
      title={item.title}
    >
      <span style={styles.icon}>{item.icon}</span>
      {drawerOpen && (
        <span style={{ marginLeft: 10, whiteSpace: "nowrap" }}>
          {item.title}
        </span>
      )}
    </button>
  );
}

const styles = {
  item: {
    display: "flex",
    alignItems: "center",
    gap: 10,
    padding: "10px 12px",
    borderRadius: 8,
    border: "1px solid",
    cursor: "pointer",
    fontSize: "0.9rem",
    fontWeight: 500,
    background: "none",
    width: "100%",
    textAlign: "left",
    transition: "all 0.15s",
    // marginTop: "20px",
  },
  icon: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    flexShrink: 0,
  },
};

export default NavItem;
